/// <amd-module name="VSSUI/Components/Menu/MenuButton" />
import * as React from "react";
import { ExpandableButton } from "VSSUI/Button";
import { IExpandable } from "VSSUI/Expandable";
import { IFocusable } from "VSSUI/Utilities/Focus";
import { IOffset, IOrigin, IPoint } from "VSSUI/Utilities/Position";
import { ContextualMenu } from "./Menu";
import { IMenuItem } from "./Menu.Props";
import { IMenuButtonProps } from "./MenuButton.Props";

export interface IMenuButtonState {
    id: string;
}

let buttonId = 1;

export class MenuButton extends React.Component<IMenuButtonProps, IMenuButtonState> implements IFocusable<{}>, IExpandable {
    private dropdownButton = React.createRef<ExpandableButton>();

    public constructor(props: Readonly<IMenuButtonProps>) {
        super(props);
        this.state = {
            id: this.props.id || "menu-button-" + buttonId++
        };
    }

    public expand = () => {
        if (this.dropdownButton.current) {
            this.dropdownButton.current.expand();
        }
    };

    public collapse = () => {
        if (this.dropdownButton.current) {
            this.dropdownButton.current.collapse();
        }
    };

    public render(): JSX.Element {
        const { hideDropdownIcon } = this.props;
        const contextualMenuProps =
            typeof this.props.contextualMenuProps === "function" ? this.props.contextualMenuProps() : this.props.contextualMenuProps;

        return (
            <ExpandableButton
                {...{ ...this.props, menuProps: contextualMenuProps.menuProps }}
                dropdownId={contextualMenuProps?.menuProps?.id}
                hideDropdownIcon={hideDropdownIcon}
                id={this.state.id}
                ref={this.dropdownButton}
                renderCallout={this.renderMenu}
            >
                {this.props.children}
            </ExpandableButton>
        );
    }

    public focus() {
        if (this.dropdownButton.current) {
            this.dropdownButton.current.focus();
        }
    }

    private renderMenu = (
        dropdown: IExpandable,
        dropdownId: string,
        anchorElement?: HTMLElement,
        anchorOffset?: IOffset,
        anchorOrigin?: IOrigin,
        anchorPoint?: IPoint,
        dropdownOrigin?: IOrigin
    ): JSX.Element => {
        const contextualMenuProps =
            typeof this.props.contextualMenuProps === "function" ? this.props.contextualMenuProps() : this.props.contextualMenuProps;
        return (
            <ContextualMenu
                anchorElement={anchorElement}
                anchorOffset={contextualMenuProps.anchorOffset || anchorOffset}
                anchorOrigin={contextualMenuProps.anchorOrigin || anchorOrigin}
                anchorPoint={contextualMenuProps.anchorPoint || anchorPoint}
                fixedLayout={contextualMenuProps.fixedLayout}
                menuOrigin={contextualMenuProps.menuOrigin || dropdownOrigin}
                menuProps={contextualMenuProps.menuProps}
                className={contextualMenuProps.className}
                onActivate={(menuItem: IMenuItem, event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
                    if (contextualMenuProps.onActivate) {
                        contextualMenuProps.onActivate(menuItem, event);
                    }
                    dropdown.collapse();
                }}
                onDismiss={dropdown.collapse}
            />
        );
    };
}
